







import Vue                 from 'vue'
import {Component}         from 'vue-property-decorator'
import CustomNotifications from '@/components/CustomNotifications.vue'

@Component({
    components: {CustomNotifications}
})
export default class App extends Vue {
}
